// Tiny helper for the JS-visible translations exposed via app/lib/i18n_js.rb.
// Pattern: window.I18n is populated by the layout (theme.html.erb etc.) from
// I18nJs.new(locale).to_json. Keys are flat dotted paths matching en.yml.

export function t(key, fallback) {
  return (window.I18n && window.I18n[key]) || fallback;
}

export function format(key, fallback, vars = {}) {
  return Object.entries(vars).reduce(
    (str, [k, v]) => str.replaceAll(`%{${k}}`, v),
    t(key, fallback),
  );
}
